import React from 'react';
import { Toolbar, Typography, type TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

// The explicit prop type restores Typography's polymorphic `component`, which
// `styled()` otherwise narrows away: callers pin the wordmark to <p> so
// `variant="h6"` stays a type-scale choice and never emits a stray heading.
export const LogoText = styled(Typography)<TypographyProps>(({ theme }) => ({
  fontWeight: 700,
  background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontSize: '1.25rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.5rem',
  },
}));

const LogoHeader = () => {
  return (
    <Toolbar sx={{ mb: 2 }}>
      <LogoText variant="h6" component="p">
        DeepThink
      </LogoText>
    </Toolbar>
  );
};

export default LogoHeader;
